var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property, unsafeHTML } from '@inter-ikea-kompis/web-component';
import { EnergyAIcon, EnergyApIcon, EnergyAppIcon, EnergyApppIcon, EnergyBIcon, EnergyCIcon, EnergyDIcon, EnergyEIcon } from '@inter-ikea-kompis/icons';
import { EnergyClassParser } from '@inter-ikea-kompis/utilities';
const EnergyClassIcon = Object.freeze({
    'A+++': EnergyApppIcon,
    'A++': EnergyAppIcon,
    'A+': EnergyApIcon,
    A: EnergyAIcon,
    B: EnergyBIcon,
    C: EnergyCIcon,
    D: EnergyDIcon,
    E: EnergyEIcon
});
const EnergyClassColor = Object.freeze({
    'A+++': '#00a651',
    'A++': '#50b848',
    'A+': '#bfd730',
    A: '#fff200',
    B: '#fdb913',
    C: '#f37021',
    D: '#ed1c24',
    E: '#ed1c24'
});
/**
 * This component will only exist for a certain time.
 */
export default class EnergyEfficiencyNonRescaled extends KompisElement {
    /**
     * @returns Template.
     */
    render() {
        const energyClass = EnergyClassParser.parseProduct(this.product);
        if (!energyClass) {
            return null;
        }
        const icon = EnergyClassIcon[energyClass];
        return html `
			<style>
				:host {
					display: flex;
					cursor: pointer;
					outline: none;
				}
				:host:before {
					content: '';
					width: ${this.theme.spacing.space50 / 16}rem;
				}
				svg {
					color: ${EnergyClassColor[energyClass]};
					width: 2.4em;
					height: 100%;
					flex-shrink: 0;
				}
			</style>
			${unsafeHTML(icon)}
		`;
    }
}
__decorate([
    property({ type: Object, required: true })
], EnergyEfficiencyNonRescaled.prototype, "product", void 0);
__decorate([
    property({ type: Object, required: true })
], EnergyEfficiencyNonRescaled.prototype, "theme", void 0);
//# sourceMappingURL=EnergyEfficiencyNonRescaled.js.map